import { Grid } from "@mui/material";

import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import CarouselFormBodyText from "./CarouselFormBodyText";
import CarouselFormMediaHeader from "./CarouselFormMediaHeader";
import CarouselFormButtonsAndActions from "./CarouselFormButtonsAndActions";
import CarouselFormCard from "./CarouselFormCard/CarouselFormCard";

const CarouselTemplateForm = (props: any) => {

    const { carouselFiles, handleChangeText, handleClick, handleClose, menuPosition, anchorEl, getMenuDisableFlag, getInput, inValidIdRefCarousel, 
        handleChangeCallField, handleChangeFieldVal, isFileUploaded, uploadFileHandlerCarousel, removeFileHandlerCarousel, 
        handleAddNewCard, handleDeleteCard, flagShowVariableTooltipForVisitWebsite, checkForAddDynamicVar, carouselInvalidId, setCarouselInvalidId, 
        handleSampleTextChangeCarousel, getWebsiteUrlValue, handleChangeCardMediaHeader, inDrawer 
    } = props;

    return (
        <Grid container 
            className={`
                ${styles.whatsappTemplateForm} ${inDrawer ? styles.whatsappTemplateForm_inDrawer : ""} 
                ${globalStyles.fullwidth}
            `}
        >

            {/* Template Configuration Title */}
            <Grid item xs={12} className={styles.whatsappTemplateForm__titleDescriptionContainer}>
                <div className={styles.whatsappTemplateForm__title}>
                    Carousel Configuration
                </div>
            </Grid>


            {/* Carousel Template Form */}
            <Grid item xs={12} className={styles.whatsappTemplateForm__formContainer}>

                <CarouselFormBodyText
                    handleChangeText={handleChangeText}
                />

                <CarouselFormMediaHeader 
                    handleChangeCardMediaHeader={handleChangeCardMediaHeader} 
                />

                <CarouselFormButtonsAndActions
                    handleClick={handleClick}
                    handleClose={handleClose}
                    menuPosition={menuPosition}
                    anchorEl={anchorEl}
                    getMenuDisableFlag={getMenuDisableFlag}
                    getInput={getInput}
                    inValidIdRefCarousel={inValidIdRefCarousel}
                    handleChangeCallField={handleChangeCallField}
                    handleChangeFieldVal={handleChangeFieldVal}
                    carouselInvalidId={carouselInvalidId}
                    setCarouselInvalidId={setCarouselInvalidId}
                />

                <CarouselFormCard
                    carouselFiles={carouselFiles}
                    isFileUploaded={isFileUploaded}
                    uploadFileHandlerCarousel={uploadFileHandlerCarousel}
                    removeFileHandlerCarousel={removeFileHandlerCarousel}
                    handleAddNewCard={handleAddNewCard}
                    handleDeleteCard={handleDeleteCard}
                    handleChangeText={handleChangeText}
                    getInput={getInput}
                    flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                    checkForAddDynamicVar={checkForAddDynamicVar}
                    handleSampleTextChangeCarousel={handleSampleTextChangeCarousel}
                    getWebsiteUrlValue={getWebsiteUrlValue}
                    carouselInvalidId={carouselInvalidId}
                />
            
            </Grid>

        </Grid>
    )

}

export default CarouselTemplateForm;
